module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "twentytwenty-container",
    style: (_vm.containerStyle),
    on: {
      "touchstart": _vm.startSlide,
      "mousedown": _vm.startSlide
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.after,
      "alt": "after"
    },
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
      },
      "load": _vm.setDimensions
    }
  }), _vm._v(" "), _c('img', {
    style: (_vm.beforeImgStyle),
    attrs: {
      "src": _vm.before,
      "alt": "before"
    },
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
      }
    }
  }), _vm._v(" "), (_vm.overlay) ? _c('div', {
    staticClass: "twentytwenty-overlay",
    style: (_vm.overlayStyle)
  }, [(_vm.beforeLabel) ? _c('div', {
    staticClass: "twentytwenty-before-label"
  }, [_vm._v(_vm._s(_vm.beforeLabel))]) : _vm._e(), _vm._v(" "), (_vm.afterLabel) ? _c('div', {
    staticClass: "twentytwenty-after-label"
  }, [_vm._v(_vm._s(_vm.afterLabel))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "twentytwenty-handle",
    style: (_vm.handleStyle),
    attrs: {
      "tabindex": "0"
    },
    on: {
      "keydown": _vm.handleArrowNavigation
    }
  }, [_c('div', {
    staticClass: "twentytwenty-arrow-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "twentytwenty-arrow-right"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23f448e0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=4ecaiejb649!./~/string-replace-webpack-plugin/loader.js?id=vjos074u90o!./src/components/dynamic-petition/BeforeAfterSlider.vue
// module id = 771
// module chunks = 0